<template>
  <form class="form mesh-selector" action="" v-if="selectedDress && meshesOfDress(selectedDress).length" @submit="submit">

    <label class="text-xsm text-grey">Select a component</label>
    <select name="mesh" id="mesh-select" v-model="selection" class="input input--select" @change="submit">
      <!--<option value="">Seleziona un componente</option>-->
      <optgroup v-if="meshesOfDress(selectedDress).length" label="Components">
        <option :selected="mesh.id === selectedMesh.id" :value="mesh.id" v-for="mesh  of meshesOfDress(selectedDress)" :key="mesh.id">{{ mesh.name | cleanMeshName }}</option>
      </optgroup>
      <optgroup v-if="accessoriesOfDress(selectedDress).length" label="Accessories">
        <option :selected="accessory.id === selectedMesh.id" :value="accessory.id" v-for="accessory  of accessoriesOfDress(selectedDress)" :key="accessory.id">{{ accessory.name | cleanMeshName }}</option>
      </optgroup>
      <optgroup v-if="selectedShoes && accessoriesOf(selectedShoes.inst).length" label="Shoes">
        <option :selected="accessory.id === selectedMesh.id" :value="accessory.id" v-for="accessory  of accessoriesOf(selectedShoes.inst)" :key="accessory.id">{{ accessory.name | cleanMeshName }}</option>
      </optgroup>
    </select>

  </form>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: "MeshSelectorSelectInput",
    data() {
      return {
        selection: null,
      }
    },
    methods: {
      ...mapActions('clothes',[
        'setSelectedMesh'
      ]),
      ...mapActions('camera',[
        'focusOnSelectedMesh'
      ]),
      submit() {
        // let mesh = {}; //todo get selected mesh

        if(!this.selection) {
          return
        }

        let mesh = this.meshesOfDress(this.selectedDress).find(el => el.id === this.selection);
        // console.log(mesh);

        if(!mesh) {
          mesh = this.accessoriesOfDress(this.selectedDress).find(el => el.id === this.selection);
        }

        if(!mesh && this.selectedShoes) {
          mesh = this.accessoriesOf(this.selectedShoes.inst).find(el => el.id === this.selection);
        }

        if(!mesh) {
          return
        }

        this.focusOnSelectedMesh(mesh);
        this.setSelectedMesh(mesh);
      }
    },
    computed: {
      ...mapGetters('clothes',[
        'selectedDress',
        'selectedMesh',
        'meshesOfDress',
        'accessoriesOfDress'
      ]),
      ...mapGetters('shoes',[
        'selectedShoes'
      ]),
      ...mapGetters('mannequin',[
        'accessoriesOf'
      ])
    },
    filters: {
      cleanMeshName: function(name) {
        if(!name) {
          return '';
        }

        // console.log(name.split('-').pop().replace('ACC_',''));

        let cleanedName = name.split('-').pop();
        cleanedName = cleanedName.replaceAll('ACC_','');
        cleanedName = cleanedName.replaceAll('_',' ');
        cleanedName = cleanedName.toUpperCase();
        // console.log(cleanedName);
        return cleanedName;

      }
    },
    mounted() {
      if (this.selectedMesh) {
        this.selection = this.selectedMesh.id;
      }
    }
  }
</script>

<style scoped>
  .input--select {
    width: 100%;
    padding: 5px 10px;
    border-radius: 30px;
  }

  .mesh-selector {
    padding: 0 30px 20px;
  }

  .mesh-selector label {
    padding-left: 15px;
  }

</style>